import React from 'react';
import { CardBody } from '@components/card/card';
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NoData from '@components/NoData/NoData';

const Revaluations = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  //#region Formik
  const formik = useFormik({
    initialValues: {
      assetId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      revaluationDate: '',
      newCost: 0,
      oldCost: 0,
      adjustedAmount: 0,
      description: 'string'
    },

    // enableReinitialize: true,
    // validationSchema: AddAssetsSchema(t),

    onSubmit: values => {
      //   dispatch(
      //     addAssets({
      //       name: values.name,
      //       name2: values.name2,
      //       assetNumber: values.assetNumber,
      //       tagNumber: values.tagNumber,
      //       serialNumber: values.serialNumber,
      //       categoryId: values.categoryId,
      //       organizationId: values.organizationId,
      //       // parentAssetId: null,
      //       parentAssetId: assetsId ?? null,
      //       datePlacedInService: values.datePlacedInService,
      //       ownedLeased: values.ownedLeased,
      //       leasedId: null,
      //       newUsed: values.newUsed,
      //       originalCost: values.originalCost,
      //       adjustedCost: values.adjustedCost,
      //       salvageValue: values.salvageValue,
      //       lifeInMonths: values.lifeInMonths,
      //       depreciationMethod: values.depreciationMethod,
      //       percentage: values.percentage,
      //       description: values.description,
      //       assetCostAccount: values.assetCostAccount,
      //       deprnExpenseAccount: values.deprnExpenseAccount,
      //       deprnReserveAccount: values.deprnReserveAccount,
      //     })
      //   )
      //     .unwrap()
      //     .then(res => {
      //       // debugger;
      //       if (res?.succeeded === true) {
      //         CustomAlert({ action: 'Add' });
      //         dispatch(getAssetsList());
      //         formik.resetForm();
      //       } else {
      //         formik.setSubmitting(false);
      //         CustomAlert({ action: 'Error', msg: res?.message });
      //       }
      //     })
      //     .catch((error: any) => {
      //       formik.setSubmitting(false);
      //       CustomAlert({ action: 'Error' });
      //     });
    }
  });
  // const { values, handleChange, errors, touched, setFieldValue } = formik;
  //#endregion

  return (
    <>
      {/* <div className='section mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa fa-info-circle text-theme'></i>
          تقييم الأصــل
        </h6>
        <hr />
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className='row'>
              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('تاريخ التقييم')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control '
                    type='date'
                    name='revaluationDate'
                    onChange={handleChange}
                    value={values.revaluationDate}
                  />
                  <div className='text-danger small'>
                    {touched.revaluationDate && errors.revaluationDate}
                  </div>
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('القيمة القديمة للأصل')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control '
                    type='text'
                    name='oldCost'
                    onChange={handleChange}
                    value={values.oldCost}
                  />
                  <div className='text-danger small'>{touched.oldCost && errors.oldCost}</div>
                </div>
              </div>

              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('القيمة الجديدة للأصل')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control '
                    type='text'
                    name='newCost'
                    onChange={handleChange}
                    value={values.newCost}
                  />
                  <div className='text-danger small'>{touched.newCost && errors.newCost}</div>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('الفرق بين القيمتين ')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control '
                    type='text'
                    name='adjustedAmount'
                    onChange={handleChange}
                    value={values.adjustedAmount}
                  />
                  <div className='text-danger small'>
                    {touched.adjustedAmount && errors.adjustedAmount}
                  </div>
                </div>
              </div>

              <div className='col-lg-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('description')}</label>
                  <Form.Control
                    autoComplete='off'
                    className='form-control '
                    type='text'
                    name='description'
                    onChange={handleChange}
                    value={values.description}
                  />
                </div>
              </div>
            </div>

            <div className='text-center'>
              <div className='d-flex justify-content-between gap-2'>
                <button
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn btn-lg btn-theme mb-1 w-100'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-redo-alt fa-lg fa-fw me-2'></i>
                  )}
                  {t('إعادة تقييم')}
                </button>
              </div>
            </div>
          </Form>
        </CardBody>
      </div> */}

      <div className='section mb-4'>
        <h6 className=''>
          <i className='fas fa-clipboard-list fa-lg fa-fw me-2 text-theme'></i>
          التقييمات السابقة
        </h6>
        <hr />
        <CardBody>
          <NoData />
        </CardBody>
      </div>
    </>
  );
};

export default Revaluations;
